export const answers = [
  'No, Not at All',
  'A Little',
  'Somewhat',
  'A Lot',
  'Yes, Very Much',
]
export const slide1 = [
  {
    question:
      '1-	When an asterisk turned red indicating an incorrect response did this affect your strategy as you progressed to the next tasks within the block?',
  },
  {
    question:
      '2-	When a question mark turned red indicating an incorrect response, did this affect your strategy as you progressed to the next tasks within the block?',
  },
]
export const slide2 = [
  {
    question:
      `a.	Verbal Confirmation: "I repeated the name of the given letter when an asterisk was presented and used that repetition to determine whether it overlapped with the visualized letter.`,
    example:
      "Example: Saying 'H, H, H' aloud or silently each time an asterisk appears, and using the verbal cue to help decide if the asterisk is on or off the letter, enhancing spatial recognition and decision-making.",
  },
  {
    question:
      "b.	Spatial Fixation: “I fixed the letter's shape at certain spots on the grid to maintain its position in my visualization”",
    example:
      "Example: Visualizing the letter 'I' as starting from the top center grid point and extending straight down to the bottom center.",
  },
  {
    question:
      'c.	Letter Segmentation: "I divided the letter into smaller segments and visualized each segment separately before combining them."',
    example:
      "Example: Seeing the letter 'H' as two vertical lines connected by a horizontal line and visualizing each line one at a time.",
  },
  {
    question:
      'd.	Grid Overlay Technique: "I mentally overlaid a smaller grid or lines over the letter to help position and size it correctly within the larger grid."',
    example:
      "Example: Imagining a smaller 3x3 grid over the middle of the 5x5 grid to place and align the letter 'H' accurately.",
  },
  {
    question:
      'e.	Mental Tracing: "I mentally traced the outline of the letter repeatedly to reinforce its image on the blank grid."',
    example:
      "Example: Mentally drawing the letter 'I' from top to bottom multiple times to solidify its position and orientation.",
  },
  {
    question:
      'f.	Contrast Enhancement: "I imagined the letter in a color or brightness that contrasts strongly with the background grid to make it stand out more vividly."',
    example:
      "Example: Picturing the letter 'H' in bright white against a dark grid background to keep it visually prominent.",
  },
  {
    question: `g.	Error Correction Feedback: "I adjusted the position or shape of the letter in my visualization based on feedback from the asterisk's color changes."`,
    example:
      "Example: If an asterisk on the right side of the grid turns red, adjusting the mental image of the letter 'H' to ensure it covers the correct grid cells.",
  },
]
export const slide3 = [
  {
    question: `h.	Center-Relative Memorization: "I attempted to memorize the locations of the dots by considering each dot's position relative to the center of the grid."`,
    example:
      "Example: Remembering a dot as 'slightly left of the center' or 'directly above the center'.",
  },
  {
    question:
      'i.	Geometric Pattern Formation: "I tried to connect the dots with imaginary lines to form a shape."',
    example:
      'Example: Visualizing a triangle or square by drawing imaginary lines between the dots.',
  },
  {
    question:
      'j.	Chunking: "I grouped several dots together into clusters or segments to simplify remembering their locations."',
    example:
      'Example: Grouping all dots on the left side separately from those on the right.',
  },
  {
    question:
      'k.	Verbal Encoding: "I assigned verbal labels or names to specific configurations or locations of dots to aid in recall."',
    example:
      "Example: Naming a group of dots in a straight line as 'the ladder'.",
  },
  {
    question:
      'l.	Sequential Pathways: "I mentally retraced the sequence of dot appearances, as if drawing a line from one dot to the next in the order they appeared."',
    example:
      "Example: Recalling dots by thinking 'first the top left, then middle right, then bottom center'.",
  },
  {
    question: `m.	Use of Grid References: "I used the grid’s structure to create reference points, such as imagining lines that divide the grid into quadrants to place dots relative to these areas."`,
    example:
      "Example: Remembering a dot as being 'upper quadrant, close to the middle'",
  },
  {
    question:
      'n.	Pattern Recognition: "I identified and recalled common or repeated patterns within the configurations of dots, such as noticing symmetrical arrangements or shapes."',
    example:
      "Example: Recognizing that dots form a 'V' shape and remembering it as such.",
  },
  {
    question:
      'o.	Relational Positioning: "I focused on the spatial relationships between dots, noting which dots were adjacent or directly across from each other."',
    example:
      "Example: Remembering a dot by noting 'next to the top right dot' or 'opposite the center dot'.",
  },
  {
    question:
      'p.	Use of Mnemonics: "I created mnemonics or simple phrases to help remember the positions of dots based on their configuration."',
    example:
      "Example: Using the phrase 'Every Good Boy Does Fine' to remember the positions of five dots.",
  },
  {
    question:
      'q.	Visualization of Movement: "I imagined moving from one dot to the next in a specific pattern to aid in memorization and recall."',
    example:
      'Example: Visualizing a path that starts at the bottom left dot, moves to the middle, and then goes to the top right.',
  },
]
export const slide4 = [
  {
    question:
      'a.	Continuous Visualization: "I continuously visualized the letter on the grid while responding to both the asterisks and the question marks to manage the overlapping tasks."',
    example:
      "Example: Keeping the image of the letter 'H' consistently in mind throughout the trials, even when shifting focus to respond to the dots and question marks.",
  },
  {
    question:
      'b.	Selective Attention Switching: "I switched my attention selectively between visualizing the letter and identifying dot locations, depending on the stimulus presented."',
    example:
      'Example: Focusing intently on the letter shape when deciding if an asterisk overlaps, then briefly shifting focus to recall dot positions for responding to question marks.',
  },
  {
    question:
      'c.	Spatial Mapping: "I mapped out the grid mentally to manage the locations of both the letter and the dots, using the grid lines as reference points."',
    example:
      "Example: Using the grid structure to mentally place the letter 'I' and remember where dots appeared relative to the grid lines and the letter.",
  },
  {
    question:
      'd.	Prioritization of Visual Tasks: "I prioritized visual accuracy over speed, ensuring I accurately visualized the letter and correctly identified dot positions before responding."',
    example:
      "Example: Taking extra moments to ensure the letter 'I' is properly visualized, and the dot positions are correctly recalled before pressing any response keys.",
  },
  {
    question:
      'e.	Adaptive Strategy Use: "I adapted my strategies based on the feedback received, using correct or incorrect responses to refine my visualization and memory recall techniques."',
    example:
      "Example: Adjusting the visualization of the letter 'H' or the recalled dot locations if the asterisk or question marks turn red, using the feedback to enhance accuracy in subsequent trials.",
  },
  {
    question:
      'f.	Phase-Specific Focus: "Although keeping the letter visualization when recalling the locations was not mandatory, I maintained a residual mental image of the letter to assist in responding to question marks."',
    example:
      "Example: Keeping a faded image of the letter 'H' in mind while focusing more on whether dots were presented in those cells, blending visualization with spatial memory as needed.",
  },
]
